import emailRegex from "email-regex";
import { useRef } from "react";
import { TextField as RTextField } from "reshaped";

import { Field } from "./Field";
import {
    type AnyFieldProps,
    type RChangeEvent,
    useFieldDirtyness,
    useFieldId,
    useFieldImperativeHandle,
    useValidity,
    validationFn,
} from "./utilities";

type TextFieldType = "text" | "email" | "password";

export type TextFieldProps = AnyFieldProps<string> & {
    type?: TextFieldType;
};

export default function TextField(props: TextFieldProps) {
    const { type = "text", onChange } = props;
    const id = useFieldId(props);
    const value = props.value || "";
    const inputRef = useRef<HTMLInputElement>(null);

    const { isDirty, setDirty } = useFieldDirtyness(props);

    const validity = useValidity(props, [
        validationFn(type, (v) => {
            if (type === "email" && !emailRegex().test(v)) throw new Error("Invalid email");
        }),
    ]);

    const onFieldChange = (e: RChangeEvent<string>) => {
        const { value } = e;
        onChange(value ? value : null);
    };

    useFieldImperativeHandle(props, { validity, setDirty, inputRef });

    return (
        <Field {...props} isDirty={isDirty} validity={validity}>
            <RTextField
                name={id}
                value={value}
                onChange={onFieldChange}
                inputAttributes={{ type: type, onBlur: setDirty, ref: inputRef }}
            />
        </Field>
    );
}
